import BasePage from "@/presentation/BasePage";
import { Component, Inject } from "vue-property-decorator";
import Vue2Filters from "vue2-filters";
import AlertMixin from "@/shared/alert/alert.mixin";
import { mixins } from "vue-class-component";
import HeaderService from "./header.service";

@Component({
  mixins: [Vue2Filters.mixin],
})
export default class HeaderContainer extends mixins(AlertMixin) {
  @Inject("headerService") private headerService: () => HeaderService;

  private full_name: string = "";
  private personalUser: any = "";
  HeaderService;

  public created() {
    const user = JSON.parse(localStorage.getItem("user"));
    this.getUserByUsers(user.username);

    console.log(123123);
  }

  public getUserByUsers(username) {
    let query: any = {
      username: [],
    };
    query.username = [username];
    this.headerService()
      .getPersonalInfo(query)
      .then(
        (res) => {
          this.full_name = res[0].full_name;
        },
        (erro) => {}
      );
  }

  public hanlderPushPresonInFor() {
    this.$router.push("/personal-info");
    // let loc = window.location;
    // loc.href = window.location.origin + "/personal-info";
  }

  public logOut() {
    localStorage.removeItem("user");
    let loc = window.location;
    loc.href = window.location.origin + "/Login";
  }
}
